<template>
  <div class="form container">
    <div class="form-article formResponsive formHorizontal">
      <div class="form-article-item form-article-item-approved">
        <label class="container2" for="review-approved-yes">
          <input
            class="rsform-checkbox"
            type="radio"
            id="review-approved-yes"
            :value="review.approved"
            :checked="review.approved"
            v-on:input="review.approved = true"
            :disabled="disabled"
          />
          Approved
          <span class="checkmark"></span>
        </label>
        <label class="container2" for="review-approved-no">
          <input
            class="rsform-checkbox"
            type="radio"
            id="review-approved-no"
            :value="review.approved"
            :checked="!review.approved"
            v-on:input="review.approved = false"
            :disabled="disabled"
          />
          Not Approved
          <span class="checkmark"></span>
        </label>
      </div>
      <div class="form-article-item form-article-item-corrections">
        <label class="container2" for="review-corrections-yes">
          <input
            class="rsform-checkbox"
            type="radio"
            id="review-corrections-yes"
            :value="review.corrections"
            :checked="review.corrections"
            v-on:input="review.corrections = true"
            :disabled="disabled"
          />
          With corrections
          <span class="checkmark"></span>
        </label>
        <label class="container2" for="review-corrections-no">
          <input
            class="rsform-checkbox"
            type="radio"
            id="review-corrections-no"
            :value="review.corrections"
            :checked="!review.corrections"
            v-on:input="review.corrections = false"
            :disabled="disabled"
          />
          Without corrections
          <span class="checkmark"></span>
        </label>
      </div>
      <div class="form-article-item form-article-item-text">
        <wysiwyg v-if="!disabled" class="text-editor" v-model="review.text" />
        <textarea
          v-if="disabled"
          disabled
          class="text-editor"
          v-model="review.text"
        />
        <p class="footer">
          Obligatory in case of non approval or approval with corrections; these
          notes will be e-mailed to the author. Máx 2000 carat.
        </p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "ReviewForm",
  props: {
    review: {
      type: Object,
      default: function () {
        return {};
      },
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
};
</script>

<style lang="scss">
.form-article-item {
  label.container2 {
    display: inline-block;
    cursor: pointer;
  }
  p.footer {
    font-size: 0.8em;
    text-align: right;
    margin-top: 1em;
  }
}
.form-article-item-approved,
.form-article-item-corrections {
  padding-bottom: 0.5em;
}
.form-article-item-corrections,
.form-article-item-text {
  padding-top: 0.5em;
}
.text-editor {
  background-color: white;
}
</style>



// WEBPACK FOOTER //
// ReviewForm.vue?5680b044